import type { RouteRecordRaw } from 'vue-router';

const vrtNotFound: RouteRecordRaw = {
  // Always leave this as last one,
  path: '/:catchAll(.*)*',
  name: 'vrtNotFound',
  component: () => import('pages/vpgNotFound.vue'),
};

export default vrtNotFound;
